import { ManipulationType } from "gql/graphql";
import {
  AuditOutlined,
  MessageOutlined,
  SmileOutlined,
  SoundOutlined,
  TableOutlined,
} from "@ant-design/icons";
import Button from "@/shared/form/button";
import { useTranslations } from "use-intl";

const manipulationTypeButtons = [
  {
    type: ManipulationType.MorePolitely,
    icon: <SmileOutlined />,
  },
  {
    type: ManipulationType.MoreBusinesslike,
    icon: <AuditOutlined />,
  },
  {
    type: ManipulationType.MoreConcise,
    icon: <MessageOutlined />,
  },
  {
    type: ManipulationType.MoreUnderstand,
    icon: <SoundOutlined />,
  },
  {
    type: ManipulationType.MorePositive,
    icon: <SmileOutlined />,
  },
  {
    type: ManipulationType.MoreDetailed,
    icon: <TableOutlined />,
  },
];

export function ManipulationTypeButtons({
  loading,
  manipulationType,
  manipulate,
}: {
  loading: boolean;
  manipulationType: ManipulationType | null;
  manipulate: (type: ManipulationType) => void;
}) {
  const t = useTranslations("AI");

  return (
    <div className={"flex flex-wrap items-center gap-2"}>
      <div>{t("Make text more")}:</div>
      {manipulationTypeButtons.map(({ icon, type }) => (
        <Button
          key={type}
          size={"small"}
          icon={icon}
          onClick={() => manipulate(type)}
          loading={loading && manipulationType === type}
        >
          {t(type)}
        </Button>
      ))}
    </div>
  );
}
